import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody } from "reactstrap"

import { connect } from "react-redux";

import Swal from 'sweetalert2'
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { handleErrors, showToaster } from "components/Common/common";
import { PAGECODE, PAGEPATHS, USERTYPES } from "components/Common/Constant";
import EditModal from "./EditModal";
import AddModal from "./AddModal";
import { useSelector } from "react-redux";

const DatatableTables = (props) => {
  document.title = "User Management";
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  console.log(editUserData, "editUserData");

  const [isModifying, setIsModifying] = useState(false);
  const [addUserData, setAddUserData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    userType: USERTYPES.Global,
    // phoneNumber: 0,
    password: ''
  });

  useEffect(() => {
    props.setBreadcrumbItems('User Management', [])
  })

  const user = useSelector((state) => state?.users.users)

  const handleClick = async (type, users) => {
    console.log('INITIAL - users:', users);

    try {
      if (type === 1) {
        setModal(true)
        setEditUserData(users)
        return
      }
      if (type === 2) {
        const custom = '<div style="display: flex; flex-direction: column;"><i class="mdi mdi-trash-can-outline" style="font-size: 4em; color:rgb(236, 111, 111);"></i> <span>Are you sure?</span></div>'
        Swal.fire({
          title: custom,
          html: "You won’t be able to undo this!",
          showCancelButton: true,
          confirmButtonColor: "#6f7bec",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete!"
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const { data } = await axiosInstance.delete(`${ApiNames.USER_DELETE}/${users._id}`)
              setUserData((prev) => ({
                ...prev,
                columns: prev.columns,
                rows: prev.rows.filter(u => u._id !== users._id)
              }))
              showToaster(data.status, data.message)
            } catch (error) {
              handleErrors(error)
            }
          }
        });
      }
      if (type === 3) {
        console.log('users:', users);
        const permissions = !users.permissions
          ? { read: [], write: [] }
          : users.permissions
        console.log('permissions:', permissions);
        navigate(PAGEPATHS.Accessmanage,
          {
            state: {
              user: { ...users, permissions }
            }
          })
      }
    } catch (error) {
      handleErrors(error)
    }
  }

  const formatAction = (data) => {
    return (
      <div className="text-nowrap">
        <button className="waves-effect btn btn-link text-dark" variant="warning" size="sm" onClick={() => handleClick(1, data)}>Edit</button>{'|'}
        <button className="waves-effect btn btn-link text-dark" variant="danger" size="sm" onClick={() => handleClick(2, data)}>Delete</button>{'|'}
        <button className="waves-effect btn btn-link text-dark" variant="success" size="sm" onClick={() => handleClick(3, data)}>Access</button>
      </div>
    )
  }

  const getUserList = async () => {
    try {
      const endpoint = user.userType === USERTYPES.Admin
        ? ApiNames.USER_LIST
        : ApiNames.ORGANIZATION_LIST

      const { data } = await axiosInstance.get(endpoint)
      const validData = data.data.reduce((a, v) => {
        const { firstname, lastname, email, userType, _id, __v, organizationId, branch } = v
        const format = {
          _id,
          name: firstname ? `${firstname} ${lastname}` : '-',
          email,
          organizationId,
          branch: branch,
          type: userType,
          action: (formatAction(v)),
          __v
        }
        a.push(format)
        return a
      }, [])

      const adminCol = {
        label: "Action",
        field: "action",
        sort: "asc",
        width: 150,
      }

      setUserData((prev) => {
        let validCols = user.userType === USERTYPES.Admin
          ? [...prev.columns, adminCol]
          : prev.columns

        validCols = validCols.reduce((unique, col) => {
          if (!unique.some(u => u.field === col.field)) {
            unique.push(col);
          }
          return unique;
        }, []);

        return {
          ...prev,
          columns: validCols,
          rows: validData
        }
      })
    } catch (e) {
      handleErrors(e)
    }
  }
  useEffect(() => {
    getUserList()
  }, [user])

  const [userData, setUserData] = useState({
    columns: [
      {
        label: "Name",
        field: "name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 270,
      },
      {
        label: "Organization",
        field: "branch",
        sort: "asc",
        width: 200,
      },
      {
        label: "UserType",
        field: "type",
        sort: "asc",
        width: 100,
      }
    ],
    rows: []
  })
  console.log(userData, "userDatauserData")
  const handleEditSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsModifying(true)
      const { _id, __v, permissions, organizationId, ...update } = editUserData
      const { data } = await axiosInstance.put(
        `${ApiNames.USER_UPDATE}/${_id}`,
        update,
        {
          headers: {
            'If-Match': __v,
            'Content-Type': 'application/json',
          },
        }
      )
      setModal(false)
      const updatedDetails = {
        _id,
        organizationId,
        name: editUserData.firstname ? `${editUserData.firstname} ${editUserData.lastname}` : '-',
        email: editUserData.email,
        branch: editUserData.branch,
        type: <p className={`mb-0 ${editUserData.userType}_user fw-medium`}>{editUserData.userType}</p>,
        action: (formatAction({ ...editUserData, __v: data.data })),
        __v: data.data
      }
      getUserList()
      setUserData((prev) => ({
        ...prev,
        columns: prev.columns,
        rows: prev.rows.map(u => u._id === _id ? { ...u, ...updatedDetails } : u)
      }))
      setIsModifying(false)
      showToaster(data.status, data.message)
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsModifying(false)
    }
  };

  const handleAddSubmit = async (e) => {
    try {
      e.preventDefault()
      setIsModifying(true)
      const { data } = await axiosInstance.post(ApiNames.ADD_GLOBAL_ADMIN, addUserData)
      if (data.status) {
        const _id = data.data
        const pages = Object.values(PAGECODE)
        const access = {
          read: pages,
          write: pages
        }
        const newUser = {
          _id,
          organizationId: null,
          firstname: addUserData.firstname,
          lastname: addUserData.lastname,
          email: addUserData.email,
          permissions: access,
          type: <p className={`mb-0 ${addUserData.userType}_user fw-medium`}>{addUserData.userType}</p>,
          action: (formatAction({ ...addUserData, __v: 0, _id, permissions: access })),
          __v: 0
        }
        const newData = [{ ...newUser }, ...userData.rows]
        setUserData((prev) => ({
          ...prev,
          columns: prev.columns,
          rows: newData
        }))
        setIsModifying(false)
        setAddModal(false)
        setAddUserData({
          firstname: '',
          lastname: '',
          email: '',
          userType: USERTYPES.Global,
          password: ''
        })
        // const code = data.message===''
        showToaster(data.status, data.message)
      }
    } catch (e) {
      handleErrors(e)
    } finally {
      setIsModifying(false)
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12 user-table">
          <Card>
            <CardBody style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
              {user.userType === USERTYPES.Admin && (
                <div className="flex flex-col md:flex-row gap-3 justify-center md:justify-between items-center md:items-start">
                  <span className="text-center">Manage your users and their authority over reports here.</span>
                  <button
                    type="button"
                    className="waves-effect self-center md:self-end  d-flex align-items-center justify-center waves-light btn btn-primary"
                    style={{ fontSize: "0.9rem", width: 'fit-content', marginBottom: '1em' }}
                    onClick={() => setAddModal(true)}
                  >
                    <i className="mdi mdi-plus fw-bold font-size-17 pe-1"></i>{" "}
                    Add Global Admin
                  </button>
                </div>
              )}
              <MDBDataTable responsive striped data={userData} />
            </CardBody>
          </Card>
          <Card>
            <EditModal
              modal={modal}
              setModal={setModal}
              handleSubmit={handleEditSubmit}
              editUserData={editUserData}
              setEditUserData={setEditUserData}
              isModifying={isModifying}
            />
          </Card>
          <Card>
            <AddModal
              modal={addModal}
              setModal={setAddModal}
              handleSubmit={handleAddSubmit}
              addUserData={addUserData}
              setAddUserData={setAddUserData}
              isModifying={isModifying}
            />
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables);